<script>
import { bApp, COVER_TYPE } from 'base/config'
import { addClass } from 'common/js/dom'
import { getUrlParam } from 'common/js/common'
import { URL_PARAM } from '@/utils/variables.js'

export default {
  name: 'Cover',
  directives: {
    loadimg(el) {
      const src = el.src
      const newImg = new Image()
      newImg.src = src
      newImg.onload = function() {
        addClass(el, 'img-load')
      }
    }
  },
  props: {
    plan: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      coverType: '',
      coverTypeImg: ''
    }
  },
  computed: {},
  created() {
    this.coverInit()
  },
  mounted() {
    if (bApp || getUrlParam('tData') || getUrlParam('replay') || URL_PARAM.page_form === 'crm' || URL_PARAM.cover === '0') {
      this.closeCover(true)
      return
    }
    this.$nextTick(() => {
      this.closeCover()
    })
  },
  methods: {
    coverInit() {
      const coverId = getUrlParam('coverId')
      const coverImg = getUrlParam('coverImg')
      this.coverType = coverId ? `cover_t${coverId}` : null
      this.coverTypeImg = coverImg
        ? coverImg
        : this.coverType
        ? COVER_TYPE[this.coverType]
        : ''
    },
    closeCover(value) {
      this.$emit('close', value)
    }
  }
}
</script>
<template>
  <div
    ref="cover"
    class="cover"
    :class="[coverType]"
    @click="closeCover(true)"
  >
    <div v-if="coverTypeImg" class="cover-type-inner">
      <div class="cover-type-bd">
        <img
          v-loadimg
          :src="coverTypeImg"
          class="cover-type-img"
          alt="保险让生活更美好"
        >
        <!-- {{ plan.name }} {{ plan.sex }} -->
        <p>敬呈</p>
      </div>
    </div>
    <dl v-else class="cover-inner">
      <dt class="cover-title">
        <img
          src="//img.winbaoxian.com/autoUpload/planbook/resultCoverTil_8db33f9ca805866.png"
          alt="保险让生活更美好"
        >
      </dt>
      <dd class="cover-bd">
        <div class="cover-btn-wrap">
          <div v-if="plan.avatar" class="cover-avatar">
            <img class="avatar-img" alt="name" :src="plan.avatar">
          </div>
          <i v-else class="cover-btn">亲启</i>
          <!-- {{ plan.name }} {{ plan.sex }} -->
          <p v-if="plan.avatar">
            敬呈 “{{ plan.nickname }}” 亲启
          </p>
        </div>
      </dd>
    </dl>
  </div>
</template>
<style lang="postcss" scoped>
.cover-type-inner {
  z-index: 2001;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  .cover-type-img {
    width: 100%;
    vertical-align: middle;
    opacity: 0;
    transition: all 0.3s linear;
  }
  .cover-type-bd {
    z-index: 2002;
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    transform: translate(0, -50%);
  }
  p {
    z-index: 2003;
    position: absolute;
    opacity: 0;
    width: 100%;
    bottom: 23.54%;
    text-align: center;
    font-size: 19px;
    transition: all 0.3s linear 0.3s;
  }
  .img-load {
    opacity: 1;
    + p {
      opacity: 1;
    }
  }
}
</style>
